import { sessionStorageService, StorageKeys } from '@ibk/shared-utils';
export function saveIntegrationData(entityId, data) {
    try {
        const key = `${StorageKeys.CompanyId}_${entityId}`;
        const clientKey = `${StorageKeys.ClientId}_${entityId}`;
        sessionStorageService.setItemSync(key, data.companyId);
        sessionStorageService.setItemSync(clientKey, data.clientId);
    }
    catch (error) {
        console.error('Erro ao salvar dados de integração na sessão:', error);
    }
}
export function getCompanyId(entityId) {
    try {
        const key = `${StorageKeys.CompanyId}_${entityId}`;
        return sessionStorageService.getItemSync(key);
    }
    catch (error) {
        console.error('Erro ao recuperar companyId da sessão:', error);
        return null;
    }
}
export function getClientId(entityId) {
    try {
        const key = `${StorageKeys.ClientId}_${entityId}`;
        return sessionStorageService.getItemSync(key);
    }
    catch (error) {
        console.error('Erro ao recuperar clientId da sessão:', error);
        return null;
    }
}
function isNonEmptyString(value) {
    return value !== null && value !== undefined && value.trim() !== '';
}
export function getIntegrationData(entityId) {
    const companyId = getCompanyId(entityId);
    const clientId = getClientId(entityId);
    if (isNonEmptyString(companyId) && isNonEmptyString(clientId)) {
        return { companyId, clientId };
    }
    return null;
}
export function clearIntegrationData(entityId) {
    try {
        const key = `${StorageKeys.CompanyId}_${entityId}`;
        const clientKey = `${StorageKeys.ClientId}_${entityId}`;
        sessionStorageService.removeItem(key);
        sessionStorageService.removeItem(clientKey);
    }
    catch (error) {
        console.error('Erro ao limpar dados de integração da sessão:', error);
    }
}
